export class InfoRepresentante {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
        activo: {
            value: 0,
            header: 'Activos USD:',
            required: 'Activo es requerido.',
            table: false,
            tablePorTipo: {
                FRM_TOYOTA: true,
            }
        },
        pasivo: {
            value: 0,
            header: 'Pasivos USD:',
            required: 'Pasivo es requerido.',
            table: false,
            tablePorTipo: {
                FRM_TOYOTA: true,
            }
        },
        patrimonio: {
            value: 0,
            header: 'Patrimonio USD:',
            required: 'Patrimonio es requerido.',
            table: false,
            tablePorTipo: {
                FRM_TOYOTA: true,
            }
        },
        INGR_MENSUAL: {
            value: 0,
            header: 'Ingreso mensual USD:',
            headerPorTipo: {
                FRM_TOYOTA: 'Ingresos mensuales USD:',
                FRM_DIFARE: 'Ingresos mensuales USD:',
            },
            required: 'Ingreso mensual es requerido.'
        },
        INGR_ANUAL: {
            value: 0,
            header: 'Ingreso anual USD:',
            required: 'Ingreso anual es requerido.',
            table: true,
            tablePorTipo: {
                FRM_TOYOTA: false,
                FRM_DIFARE: false,
            }
        },
        EGRE_MENSUAL: {
            value: 0,
            header: 'Egreso mensual USD:',
            headerPorTipo: {
                FRM_TOYOTA: 'Egresos mensuales USD:',
                FRM_DIFARE: 'Egresos mensuales USD:',
            },
            required: 'Egreso mensual es requerido.'
        },
        EGRE_ANUAL: {
            value: 0,
            header: 'Egresos anuales USD:',
            required: 'Egresos anuales es requerido.',
            table: true,
            tablePorTipo: {
                FRM_TOYOTA: false,
                FRM_DIFARE: false,
            }
        },
        detalle: {
            value: '',
            header: 'Detalle:',
            required: 'Detalle es requerido',
            maxLength: 'Máximo 2000 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 2000,
            min: 4,
            table: true,
            tablePorTipo: {
                FRM_TOYOTA: false,
                FRM_DIFARE: false,
            }
        },
        finalidad: {
            value: null, 
            header: 'Finalidad:', 
            required: 'Finalidad es requerido.' 
        },
        registro_mercantil: {
            value: null, 
            header: 'Registro en el Mercado de Valores:', 
            required: 'Registro mercantil es requerido.'
        },
        bolsa_valor: {
            value: null, 
            header: 'Bolsa de Valores:', 
            required: 'Bolsa de valores es requerido.'
        },
        detalle_bolsa: {
            value: '', 
            header: 'Detalle Bolsa de Valores:', 
            required: 'Detalle bolsa de valores es requerido', 
            maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres', 
            max: 200, 
            min: 4
        },
        tipo_empresa: {
            value: null, 
            header: 'Tipo de empresa:', 
            required: 'Tipo de empresa es requerido.'
        },
        venta_mensual: {
            value: 0, 
            header: 'Promedio de ventas mensuales:', 
            required: 'Venta mensual es requerido.'
        },
        costo_gasto_mensual: {
            value: 0, 
            header: 'Promedio de costos y gastos mensuales:', 
            required: 'Costo y gasto mensual es requerido.'
        },
        utilidad_mensual: {
            value: 0, 
            header: 'Promedio de utilidad mensual:', 
            required: 'Utilidad mensual es requerido.'
        },
        reforma_estatuto: {
            value: null, 
            header: '¿Se ha realizado reformas a los estatutos desde su constitución?', 
            required: 'Reforma de estatuto es requerido.'
        },
        cambio_reforma: {
            value: '', 
            header: 'En caso de haber realizado reformas, por favor detallar los principales cambios realizados:', 
            required: 'Cambio de la reforma del estatuto es requerido',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250, 
            min: 4
        },
        fecha_reforma: {
            value: '', 
            header: 'Fecha de reforma:', 
            required: 'Fecha de reforma del estatuto es requerido.'
        },
        detalle_reforma: {
            value: '',
            header: 'Breve detalle de la reforma realizada:',
            required: 'Detalle de la reforma es requerido',
            maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 200,
            min: 4
        }
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
